export function getFirstLowPointIndex(values: number[]): number {
  let low = Infinity;
  let index = -1;
  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    if (v > low) {
      break;
    }
    low = v;
    index = i;
  }
  return index;
}
